var React = require('react');

function MediumArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.9393 1.99999L19 0.939331L24.0607 5.99999L19 11.0607L17.9393 9.99999L21.1893 6.74999H0V5.24999H21.1893L17.9393 1.99999Z","fill":"currentColor"}));
}

MediumArrow.defaultProps = {"viewBox":"0 0 25 12","fill":"none"};

module.exports = MediumArrow;

MediumArrow.default = MediumArrow;
